import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from "react-router-dom";

import moment from 'moment-timezone';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";


const LogsPage = (props) => {
    const token = localStorage.getItem("JWT");
    const [allLogs, setAllLogs] = useState([]);

    const timeZone = 'Europe/Paris';

    function gettAllLogs(e) {   //recupère tout les logs 

        axios({
            method: "get",
            url: `${process.env.REACT_APP_API_URL}api/log`,
            headers: {
                Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
            }
        })
            .then((res) => {
                const formattedLogs = res.data.map((log) => ({
                    ...log,
                    createdAt: moment.tz(log.createdAt, timeZone).format('DD/MM/YY HH:mm:ss'),
                }));
                setAllLogs(formattedLogs);
            })
            .catch((err) => {
                console.log(err);
            })

    }

    function navigation(e) {       // gestion du filtre

        let focustousButton = document.getElementById("tous")
        let focusConnectionButton = document.getElementById("connection")
        let focusPromotionButton = document.getElementById("promotion")
        let focusRecrutementButton = document.getElementById("recrutement")
        let focusModifButton = document.getElementById("modifications")
        let focusEventButton = document.getElementById("event")
        // let focusInscriptionButton = document.getElementById("inscriptions")

        focustousButton.classList.remove("customMenu");
        focusConnectionButton.classList.remove("customMenu");
        focusPromotionButton.classList.remove("customMenu");
        focusRecrutementButton.classList.remove("customMenu");
        focusModifButton.classList.remove("customMenu");
        focusEventButton.classList.remove("customMenu");
        // focusAdminButton.classList.remove("customMenu");
        // focusInscriptionButton.classList.remove("customMenu");


        switch (e.target.innerText) {
            case "Tous":
                focustousButton.classList.add("customMenu");
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}api/log`,
                    headers: {
                        Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                    }
                })
                    .then((res) => {
                        const formattedLogs = res.data.map((log) => ({
                            ...log,
                            createdAt: moment.tz(log.createdAt, timeZone).format('DD/MM/YY HH:mm:ss'),
                        }));
                        setAllLogs(formattedLogs);
                    })
                    .catch((err) => {
                        console.log(err);
                    })
                break;

            case "Connection":
                focusConnectionButton.classList.add("customMenu");
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}api/log`,
                    headers: {
                        Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                    }
                })
                    .then((res) => {
                        const array = res.data.filter((data) => data.logType === "Connection");
                        const formattedLogs = array.map((log) => ({
                            ...log,
                            createdAt: moment.tz(log.createdAt, timeZone).format('DD/MM/YY HH:mm:ss'),
                        }));
                        setAllLogs(formattedLogs);
                    })
                    .catch((err) => {
                        console.log(err);
                    })
                break;

            case "Promotion":
                focusPromotionButton.classList.add("customMenu");
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}api/log`,
                    headers: {
                        Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                    }
                })
                    .then((res) => {
                        const array = res.data.filter((data) => data.logType === "Promotion");
                        const formattedLogs = array.map((log) => ({
                            ...log,
                            createdAt: moment.tz(log.createdAt, timeZone).format('DD/MM/YY HH:mm:ss'),
                        }));
                        setAllLogs(formattedLogs);

                    })
                    .catch((err) => {
                        console.log(err);
                    })
                break;
            case "Recrutement":
                focusRecrutementButton.classList.add("customMenu");
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}api/log`,
                    headers: {
                        Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                    }
                })
                    .then((res) => {
                        const array = res.data.filter((data) => data.logType === "Recrutement");
                        const formattedLogs = array.map((log) => ({
                            ...log,
                            createdAt: moment.tz(log.createdAt, timeZone).format('DD/MM/YY HH:mm:ss'),
                        }));
                        setAllLogs(formattedLogs);

                    })
                    .catch((err) => {
                        console.log(err);
                    })
                break;
            case "Modifications":
                focusModifButton.classList.add("customMenu");
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}api/log`,
                    headers: {
                        Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                    }
                })
                    .then((res) => {
                        const array = res.data.filter((data) => data.logType === "Modifications");
                        const formattedLogs = array.map((log) => ({
                            ...log,
                            createdAt: moment.tz(log.createdAt, timeZone).format('DD/MM/YY HH:mm:ss'),
                        }));
                        setAllLogs(formattedLogs);

                    })
                    .catch((err) => {
                        console.log(err);
                    })
                break;
            case "Event":
                focusEventButton.classList.add("customMenu");
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}api/log`,
                    headers: {
                        Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                    }
                })
                    .then((res) => {
                        const array = res.data.filter((data) => data.logType === "event");
                        const formattedLogs = array.map((log) => ({
                            ...log,
                            createdAt: moment.tz(log.createdAt, timeZone).format('DD/MM/YY HH:mm:ss'),
                        }));
                        setAllLogs(formattedLogs);

                    })
                    .catch((err) => {
                        console.log(err);
                    })
                break;

            // case "Boutique":
            //     focusBoutiqueButton.classList.add("customMenu");
            //     axios({
            //         method: "get",
            //         url: `${process.env.REACT_APP_API_URL}api/log`,
            //     })
            //         .then((res) => {
            //             const array = res.data.filter((data) => data.logType === "Boutique");
            //             const formattedLogs = array.map((log) => ({
            //                 ...log,
            //                 createdAt: moment.tz(log.createdAt, timeZone).format('DD/MM/YY HH:mm:ss'),
            //             }));
            //             setAllLogs(formattedLogs);
            //         })
            //         .catch((err) => {
            //             console.log(err);
            //         })
            //     break;

            // case "Admin":
            //     focusAdminButton.classList.add("customMenu");
            //     axios({
            //         method: "get",
            //         url: `${process.env.REACT_APP_API_URL}api/log`,
            //     })
            //         .then((res) => {
            //             const array = res.data.filter((data) => data.logType === "Admin");
            //             const formattedLogs = array.map((log) => ({
            //                 ...log,
            //                 createdAt: moment.tz(log.createdAt, timeZone).format('DD/MM/YY HH:mm:ss'),
            //             }));
            //             setAllLogs(formattedLogs);
            //         })
            //         .catch((err) => {
            //             console.log(err);
            //         })
            //     break;

            // case "Inscriptions":
            //     focusInscriptionButton.classList.add("customMenu");
            //     axios({
            //         method: "get",
            //         url: `${process.env.REACT_APP_API_URL}api/log`,
            //     })
            //         .then((res) => {
            //             const array = res.data.filter((data) => data.logType === "Inscriptions");
            //             const formattedLogs = array.map((log) => ({
            //                 ...log,
            //                 createdAt: moment.tz(log.createdAt, timeZone).format('DD/MM/YY HH:mm:ss'),
            //             }));
            //             setAllLogs(formattedLogs);
            //         })
            //         .catch((err) => {
            //             console.log(err);
            //         })
            //     break;

            default:
        }
    }

    useEffect(() => {
        gettAllLogs()
        let focustousButton = document.getElementById("tous")
        focustousButton.classList.add("customMenu");
    }, []);

    return (

        <div className='ongletLogs'>

            <Link className='exitButton' to="/profil"><FontAwesomeIcon icon={faArrowLeft} /></Link>


            <div className='ongletLogs__filtres'>
                <button id='tous' onClick={navigation}>Tous</button>
                <button id='connection' onClick={navigation}>Connection</button>
                <button id='promotion' onClick={navigation}>Promotion</button>
                <button id='recrutement' onClick={navigation}>Recrutement</button>
                <button id='modifications' onClick={navigation}>Modifications</button>
                <button id='event' onClick={navigation}>Event</button>
                {/* <button id='boutique' onClick={navigation}>Boutique</button>
                <button id='admin' onClick={navigation}>Admin</button>
                <button id='inscriptions' onClick={navigation}>Inscriptions</button> */}
            </div>
            <div className='ongletLogs__content'>
                {allLogs.map(logs => (
                    <span key={logs.id} style={{ color: logs.logStatut === 1 ? "green" : "red" }}>
                        <p>{logs.response}</p>
                        <p>{logs.createdAt}</p>
                    </span>

                ))}
            </div>
        </div>

    );
}

export default LogsPage;